// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__2mWeF","title":"ClientReferral_title__3HDnM","itemText":"ClientReferral_itemText__18sMz"};